import React from "react";
import styled from "styled-components";
import moment from "moment";
import typo from "../../../constants/dictionaries";
import helper from '../../../helper/helper'
import colors, { getColorFromStatus } from "../../../constants/colors";
import {Tag} from 'antd'

const Status = ({ value, trangthai } = {}) => {
  if (trangthai === 1) {
    return <Tag color="red">{typo.cscore_expired}</Tag>
  } else {
    return <Tag color="green">{typo.cscore_validated}</Tag>
  }
};

export default Status;
